import { render } from "./ToolsList.vue?vue&type=template&id=d97c7eb2"
import script from "./ToolsList.vue?vue&type=script&lang=js"
export * from "./ToolsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__